import React, { useEffect, useState } from "react";
import { Dropdown, Table, Button, Form, Col, Row } from "react-bootstrap";
import ActionsDropdown from "components/actions-dropdown/ActionsDropdown";
import queryPracticeGroupMembers from "services/practice-group/queryPracticeGroupMembers";
import promoteOrDemoteToAdmin from "services/practice-group/promoteOrDemoteToAdmin";
import removeUserFromPracticeGroup from "services/practice-group/removeUserFromPracticeGroup";
import createPracticeGroupForPro from "services/practice-group/createPracticeGroupForPro";

import styles from "./PracticeSetting.module.scss";

const TeamMembers = () => {
  const [members, setMembers] = useState<PracticeGroupOrchidProMember[]>();
  const [, setError] = useState<any>();

  useEffect(() => {
    queryPracticeGroupMembers().then(setMembers).catch(setError);
  }, []);

  const updateAdminRole = async (member: PracticeGroupOrchidProMember) => {
    console.log(member);

    try {
      await promoteOrDemoteToAdmin(
        member.cognito_sub,
        member.practice_group_role === "ADMIN" ? false : true,
      );
    } catch (error) {
      setError(error);
    }
  };

  const removeMemberFromPracticeGroup = async (orchidProUserId: string) => {
    try {
      await removeUserFromPracticeGroup(orchidProUserId);
    } catch (error) {
      setError(error);
    }
  };

  const [name, setName] = useState<string>("");
  const [description, setDescription] = useState<string>("");

  const createPracticeGroup = async (e) => {
    e.preventDefault();
    try {
      await createPracticeGroupForPro(name, description);
    } catch (error) {
      setError(error);
    }
  };

  return (
    <div className={styles["practice-setting__body"]}>
      <div className={styles["practice-setting__section"]}>
        <div className={styles["practice-setting__section-title"]}>
          Team Members
        </div>
        <Form noValidate onSubmit={(e) => createPracticeGroup(e)}>
          <Row>
            <Form.Group as={Col} md="3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Col} md="9">
              <Form.Label>Description</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Form.Group>
          </Row>

          <Button type="submit">Create Group</Button>
        </Form>

        <Table>
          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Consent</th>
              <th>Status</th>
              <th>Role</th>
            </tr>
          </thead>
          <tbody>
            {members?.map((member, index) => {
              return (
                <tr key={index}>
                  <td>{member.first_name || ""}</td>
                  <td>{member.last_name || ""}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  {/* <td>{member.email}</td> */}
                  <td>{member.practice_group_role}</td>
                  <td>
                    <ActionsDropdown drop={"down"}>
                      <Dropdown.Item
                        onClick={() => {
                          updateAdminRole(member);
                        }}
                      >
                        {member.practice_group_role === "ADMIN"
                          ? "Remove Admin privileges"
                          : "Give Admin privileges"}
                      </Dropdown.Item>
                      <Dropdown.Item>Archive account</Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          removeMemberFromPracticeGroup(member.cognito_sub);
                        }}
                      >
                        Remove account
                      </Dropdown.Item>
                    </ActionsDropdown>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default TeamMembers;
